import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from 'styles/theme';

interface CardProps {
  children: ReactNode;
}

const Card: React.FC<CardProps> = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default Card;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: ${theme.colors.content_background};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.dimensions.card.borderRadius};
  padding: 1.5rem 1rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

  width: 100%;
  max-width: ${theme.dimensions.card.width};
`;
